var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "relevantApp",
          style: { backgroundColor: _vm.backgroundColor },
          attrs: {
            inline: true,
            model: _vm.relevantApp,
            "label-width": "200px",
            size: "small"
          }
        },
        [
          _c("el-form-item", { attrs: { label: "Τύπος αίτησης" } }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.applicationTypeDescription(
                    _vm.relevantApp.applicationType
                  )
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          !_vm.isRelevantReappraisal
            ? _c("el-form-item", { attrs: { label: "Τύπος τίτλου" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.translate(_vm.relevantApp.degreeType)) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.relevantApp.degreeType === "bachelor"
            ? _c("el-form-item", [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.relevantApp.consideration
                        ? "με Συνυποβολή"
                        : "χωρίς Συνυποβολή"
                    ) +
                    "\n      " +
                    _vm._s(
                      _vm.relevantApp.correspondence
                        ? " / με Αντιστοίχιση"
                        : " / χωρίς Αντιστοίχιση"
                    ) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "Αριθμός αίτησης" } }, [
            _vm._v("\n      " + _vm._s(_vm.relevantApp.id) + "\n    ")
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "Αριθμός Πρωτοκόλλου" } }, [
            _vm._v("\n      " + _vm._s(_vm.relevantApp.protocol) + "\n    ")
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "Αριθμός Πράξης" } }, [
            _vm._v("\n      " + _vm._s(_vm.relevantApp.praxeisNo) + "\n    ")
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "Απόφαση Προέδρου" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.decisionDescription(_vm.relevantApp.decision_id)) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          !_vm.isRelevantReappraisal
            ? _c("titles", { attrs: { application: _vm.relevantApp } })
            : _vm._e(),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "margin-left": "15px",
                "margin-top": "15px",
                "margin-bottom": "15px"
              }
            },
            [_c("b", [_vm._v("Επισυναπτόμενα Αρχικής Αίτησης")])]
          ),
          _vm._v(" "),
          _c("attached-documents", {
            attrs: {
              attachedDocumentsTable: _vm.attachedDocumentsTable,
              neededDocuments: _vm.relevantApp.neededDocuments,
              appId: _vm.relevantApp.id
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isRelevantReappraisal && _vm.relevantApp.relevantApplication
        ? [
            _c("div", { staticClass: "relevant-app-title" }, [
              _c("h3", [
                _c("b", [
                  _vm._v(
                    "Σχετική αίτηση της Αίτησης Επανεξέτασης: " +
                      _vm._s(_vm.relevantApp.id)
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("relevant-app", {
              staticClass: "relevant-app-style",
              attrs: {
                relevantApp: _vm.relevantApp.relevantApplication,
                backgroundColor: "#f7f7f7"
              }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-405c6423", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-405c6423","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/RelevantApp.vue
// module id = null
// module chunks = 